export const CHARITY_CATEGORY_TO_KEY = {
  'Arts and Culture': 1001,
  Animals: 1004,
  'Children and Youth Development': 1011,
  'Crime Prevention and Justice': 1006,
  'Disaster Relief': 1009,
  'Employment and Professional Associations': 1007,
  Environment: 1003,
  'Health and Medicine': 1005,
  'Housing, Homelessness and Hunger': 1008,
  'Human Services': 1012,
  International: 1013,
  'Military and Veterans': 1017,
  'Philanthropy, Grants, Other': 1015,
  'Religion and Spirituality': 1018,
  'Schools and Education': 1002,
  'Science and Research': 1016,
  'Society and Communities': 1014,
  'Sports and Recreation': 1010,
}
